import React from 'react';
const featureCards = [{
  src: 'https://cdn.magicpatterns.com/uploads/bnHNtgiZsCepwF9sAubUbC/1_web.jpg',
  alt: '+1000 Diseños Premium - Todos los personajes que tus hijos aman'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/74GJNcEhVouFuoZ1jGfojf/2_web.jpg',
  alt: 'Kit Completo de Decoración - Invitaciones, toppers, cajitas, banderines y más'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2Q5PgreJH2RxkK4jJM4SPA/3_web.jpg',
  alt: 'Fácil de usar - Formatos PDF, PNG, SVG y DXF, editable desde tu móvil'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/hBGmWm7jH65JXzLLzqABkq/4_web.jpg',
  alt: 'Oportunidad de negocio - Guía completa para emprender'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/wLRUHeXjruhF9VsdPJHoks/5_web.jpg',
  alt: 'Descarga inmediata - Acceso por email al instante'
}];
export function WhatsIncluded() {
  return <section className="py-16 px-4 bg-white" data-id="element-494">
      <div className="max-w-5xl mx-auto" data-id="element-495">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-teal-500 mb-12" data-id="element-496">
          ⭐ ¿QUÉ INCLUYE EL KIT?
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-497">
          {featureCards.map((card, index) => <div key={index} className={`rounded-3xl overflow-hidden shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 ${index === featureCards.length - 1 && featureCards.length % 3 !== 0 ? 'sm:col-span-2 lg:col-span-1' : ''}`} data-id="element-498">
              <img src={card.src} alt={card.alt} className="w-full h-full object-cover aspect-square" data-id="element-499" />
            </div>)}
        </div>
      </div>
    </section>;
}